import {Box, Paper} from '@mui/material';
import React, {useRef} from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import VehicleForm from '../../forms/VehicleForm';
import JobVehicles from './JobVehicles';
import withJob from './withJob';

const NewJobVehicle = ({job, onBack, onNext}) => {
  /** @type {({current: VehicleForm})} */
  const formRef = useRef();
  return job ? (
    <>
      <Header>Add a New Vehicle</Header>
      <Paper component={Box} padding={2}>
        <VehicleForm
          ref={formRef}
          vehicle={{}}
          job={job}
          contact={job.end_user ?? job.contact}
          company={job.company}
          onSaved={() => onNext(
            {type: JobVehicles.type, id: JobVehicles.type}
          )}
        />
      </Paper>
      <Controls
        onBack={() => onBack({type: JobVehicles.type, id: JobVehicles.type})}
        onNext={() => formRef.current.save()}
        nextLabel="Save New Vehicle"
      />
    </>
  ) : null;
};

NewJobVehicle.type = 'NEW_JOB_VEHICLE';

export default withJob(NewJobVehicle);
